"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.logoIconKeys = exports.logoIconColors = exports.logoIconTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var LogoIcons = _interopRequireWildcard(require("../../../assets/icons/logos/icons"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logoMapper = {
  speachmark: {
    black: "ic_Black__Tranparant",
    red: "ic_Red",
    white: "ic_White",
    transparent: "ic_White__Transparant"
  },
  horizontal: {
    black: "ic_Horizontal__Black",
    red: "ic_Horizontal__Red__SpeechmarkWhite",
    white: "ic_Horizontal__White",
    transparent: "ic_Horizontal__White__Speechmarkred"
  },
  vertical: {
    black: "ic_Vertical__Black",
    red: "ic_Vertical__Red__SpeechmarkWhite",
    white: "ic_Vertical__White",
    transparent: "ic_Vertical__White__SpeechmarkRed"
  }
};
var viewBoxMapper = {
  speachmark: "0 0 284 284",
  horizontal: "0 0 246 60",
  vertical: "0 0 175 121"
};
/**
 * ** The minimum size of the icon is 30px within digital applications. **
 */

var LogoIcon = function LogoIcon(_ref) {
  var type = _ref.type,
      color = _ref.color,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    component: LogoIcons[logoMapper[type][color]],
    viewBox: viewBoxMapper[type],
    style: {
      width: width,
      height: height
    }
  });
};

LogoIcon.propTypes = {
  /** The LogoIcon key */
  type: _propTypes.default.oneOf(["speachmark", "horizontal", "vertical"]),

  /** The color variant of the icon */
  color: _propTypes.default.oneOf(["red", "black", "white", "transparent"]),
  width: _propTypes.default.number,
  height: _propTypes.default.number
};
LogoIcon.defaultProps = {
  type: "speachmark",
  color: "red",
  width: 56,
  height: 56
};
var logoIconTypes = ["speachmark", "horizontal", "vertical"];
exports.logoIconTypes = logoIconTypes;
var logoIconColors = ["red", "black", "white", "transparent"];
exports.logoIconColors = logoIconColors;
var logoIconKeys = Object.keys(LogoIcons);
exports.logoIconKeys = logoIconKeys;
var _default = LogoIcon;
exports.default = _default;